var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#1DA687"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77267 15.2958C7.66661 15.2958 7.56449 15.2767 7.46631 15.2385C7.36752 15.201 7.28024 15.1443 7.20449 15.0685L3.40903 11.2731C3.27267 11.1367 3.20812 10.9737 3.2154 10.784C3.22327 10.5949 3.28782 10.4322 3.40903 10.2958C3.5454 10.1594 3.70843 10.0913 3.89812 10.0913C4.08721 10.0913 4.24237 10.1594 4.36358 10.2958L7.77267 13.7049L15.6363 5.84126C15.7575 5.7049 15.9166 5.63672 16.1136 5.63672C16.3105 5.63672 16.4696 5.7049 16.5909 5.84126C16.7272 5.97763 16.7954 6.14036 16.7954 6.32945C16.7954 6.51914 16.7272 6.68217 16.5909 6.81854L8.34085 15.0685C8.26509 15.1443 8.17812 15.201 8.07994 15.2385C7.98115 15.2767 7.87873 15.2958 7.77267 15.2958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Check box.f4a1186b0da4eb8fce99f6d345bf266d.svg";
export { ForwardRef as ReactComponent };